<template>
  <div class="donut-wrapper compact">
    <p class="list__header mb-3">Ingresos por categoría</p>

    <div class="filters d-flex align-center justify-center flex-wrap mb-2">
      <v-menu
        ref="startDate"
        v-model="startDateMenu"
        :close-on-content-click="false"
        :return-value.sync="startDate"
        transition="scale-transition"
        offset-y
        max-width="280px"
        min-width="280px"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            class="chart-input"
            dense
            hide-details
            v-model="startDate"
            label="Inicio"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="startDate" locale="es" scrollable>
          <v-spacer/>
          <v-btn text color="primary" @click="startDateMenu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.startDate.save(startDate); fetchData()">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-menu
        ref="endDate"
        v-model="endDateMenu"
        :close-on-content-click="false"
        :return-value.sync="endDate"
        transition="scale-transition"
        offset-y
        max-width="280px"
        min-width="280px"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            class="chart-input mx-2"
            dense
            hide-details
            v-model="endDate"
            label="Fin"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker v-model="endDate" locale="es" scrollable>
          <v-spacer/>
          <v-btn text color="primary" @click="endDateMenu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.endDate.save(endDate); fetchData()">OK</v-btn>
        </v-date-picker>
      </v-menu>

      <v-switch
        v-model="includeInactive"
        inset
        hide-details
        class="ml-2"
        label="Secciones inactivas"
        @change="fetchData"
      />

    </div>

    <div v-if="loading" class="d-flex justify-center py-4">
      <v-progress-circular indeterminate />
    </div>

    <div v-else>
      <ApexChart
        type="donut"
        :width="'100%'"          
        :height="height"      
        :options="options"
        :series="series"
        class="chart"
      />

      <p v-if="showTotal && totalMonto !== null" class="amount-summary mt-2">
        Total: <b>S/ {{ totalMonto.toLocaleString('es-PE') }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'IncomesByCategoryDonut',
  props: {
    width:  { type: [String, Number], default: '100%' },
    height: { type: [String, Number], default: 185 },
    showTotal: { type: Boolean, default: true }
  },
  data () {
    return {
      loading: false,
      series: [],
      totalMonto: null,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      includeInactive: false,
      options: {
        labels: [],
        legend: { position: 'bottom', fontSize: '12px' },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`
        },
        tooltip: {
          y: { formatter: (val) => `S/ ${Number(val || 0).toLocaleString('es-PE')}` }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%',
              labels: { show: true, total: { show: true, fontSize: '15px' } }
            }
          }
        }
      }
    }
  },
  methods: {
    setDefaultMonthRange () {
      const start = new Date()
      start.setDate(1)
      const end = new Date(start.getFullYear(), start.getMonth() + 1, 0)
      this.startDate = start.toISOString().substring(0, 10)
      this.endDate   = end.toISOString().substring(0, 10)
    },
    async fetchData () {
      this.loading = true
      try {
        const params = {}
        if (this.startDate) params.fecha_inicio = this.startDate
        if (this.endDate)   params.fecha_fin    = this.endDate
        if (this.includeInactive) params.include_inactive = 1
        const { data } = await axios.get('api/admin/graficas/ingresos_por_categoria_seccion/', { params })

        const labels = (data || []).map(i => i.categoria_nombre || '—')
        const values = (data || []).map(i => Number(i.monto_total || 0))

        this.options = { ...this.options, labels }
        this.series  = values

        const total = values.reduce((a, b) => a + (Number(b) || 0), 0)
        this.totalMonto = Number(total.toFixed(2))
      } catch (e) {
        console.error('Error cargando ingresos_por_categoria_seccion:', e)
        this.series = []
        this.totalMonto = 0
        this.options = { ...this.options, labels: [] }
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.setDefaultMonthRange()
    this.fetchData()
  }
}
</script>

<style scoped>
.donut-wrapper {
  width: 100%;
  background: #FFF;
  border-radius: 15px;
  padding: 10px 12px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 8px;
}
.list__header {
  margin: 0;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  color: #455A64;
}
.amount-summary {
  margin-top: 2px;
  font-size: 12px;
  color: #455A64;
  text-align: center;
}
.chart-input {
  max-width: 150px;
}
.filters { gap: 6px; }
.chart { display: block; }
</style>

